import API from "../api";

// call api update settings
const updateSettings = async (settings) => {
  try {
    const response = await API.post(
      "settings",
      JSON.stringify(settings), 
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

const SettingServices = {
  updateSettings
}

export {
  SettingServices as default,
  updateSettings,
}